import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgTelegramIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2Zm6.489 9.521c-.211 2.214-1.122 7.586-1.586 10.065-.196 1.049-.583 1.401-.957 1.435-.813.075-1.43-.537-2.218-1.053-1.232-.808-1.928-1.311-3.124-2.099-1.382-.911-.486-1.412.302-2.23.206-.214 3.788-3.472 3.858-3.768.009-.037.017-.175-.065-.248-.082-.073-.203-.048-.29-.028-.124.028-2.092 1.329-5.905 3.903-.559.384-1.065.571-1.518.561-.5-.011-1.461-.283-2.176-.515-.877-.285-1.574-.436-1.513-.92.032-.252.379-.51 1.042-.773 4.081-1.778 6.803-2.95 8.164-3.517 3.888-1.617 4.696-1.898 5.222-1.907.116-.002.375.027.543.163.142.115.181.27.199.379.019.109.042.357.023.551Z"
      fillRule="evenodd"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgTelegramStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTelegramIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TelegramIcon: any = SvgTelegramStyle;
export default TelegramIcon;
